import LearnerProfileEpicClient from 'bundles/epic/clients/LearnerProfile';

/*
 * This file includes utilities to check whether specific features should be enabled in the account-profile bundle.
 */

/**
 * This is used to determine whether we should put the user in the treatment group and initialize fullstory
 */
export const shouldEnableLearnerProfileFullStory = () => LearnerProfileEpicClient.get('enableLearnerProfileFullStory');

/**
 * This is used to determine whether we should put the user in the treatment group for edit pages and initialize fullstory
 */
export const shouldEnableLearnerProfileEditFullStory = () =>
  LearnerProfileEpicClient.get('enableLearnerProfileEditFullStory');
